import { render, staticRenderFns } from "./PptConfig.vue?vue&type=template&id=b68a9c0a&"
import script from "./PptConfig.vue?vue&type=script&lang=js&"
export * from "./PptConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b68a9c0a')) {
      api.createRecord('b68a9c0a', component.options)
    } else {
      api.reload('b68a9c0a', component.options)
    }
    module.hot.accept("./PptConfig.vue?vue&type=template&id=b68a9c0a&", function () {
      api.rerender('b68a9c0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/PptConfig.vue"
export default component.exports